/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_SnippetsInputs */

const en_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snippets`)
};

const ar_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقتطفات`)
};

const bn_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্নিপেট`)
};

const de_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snippets`)
};

const es_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmentos`)
};

const fr_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extraits`)
};

const pt_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trechos`)
};

const zh_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`代码片段`)
};

const tr_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parçacıklar`)
};

const ru_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фрагменты`)
};

const pl_image_inspector_snippets = /** @type {(inputs: Image_Inspector_SnippetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragmenty`)
};

/**
* | output |
* | --- |
* | "Snippets" |
*
* @param {Image_Inspector_SnippetsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_snippets = /** @type {((inputs?: Image_Inspector_SnippetsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_SnippetsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_snippets(inputs)
	if (locale === "bn") return bn_image_inspector_snippets(inputs)
	if (locale === "de") return de_image_inspector_snippets(inputs)
	if (locale === "es") return es_image_inspector_snippets(inputs)
	if (locale === "fr") return fr_image_inspector_snippets(inputs)
	if (locale === "pt") return pt_image_inspector_snippets(inputs)
	if (locale === "zh") return zh_image_inspector_snippets(inputs)
	if (locale === "tr") return tr_image_inspector_snippets(inputs)
	if (locale === "ru") return ru_image_inspector_snippets(inputs)
	if (locale === "pl") return pl_image_inspector_snippets(inputs)
	return en_image_inspector_snippets(inputs)
});